import React, { useState } from 'react';
import FormField from './FormField';
import '../Styles/Components/form.css';

const Form = () => {
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    cpf: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const validateField = (name, value) => {
    switch (name) {
      case 'nome':
        if (value.trim().length < 3) {
          return 'Nome deve ter pelo menos 3 caracteres';
        }
        if (!/^[a-zA-ZÀ-ÿ\s]+$/.test(value.trim())) {
          return 'Nome deve conter apenas letras';
        }
        return '';

      case 'telefone':
        const cleanedPhone = value.replace(/\D/g, '');
        if (cleanedPhone.length < 10 || cleanedPhone.length > 11) {
          return 'Telefone inválido';
        }
        return '';

      case 'email':
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(value.trim())) {
          return 'Email inválido';
        }
        return '';

      case 'cpf':
        const cleanedCPF = value.replace(/\D/g, '');
        if (cleanedCPF.length !== 11) {
          return 'CPF deve ter 11 dígitos';
        }

        // Validação básica do CPF
        let sum = 0;
        let remainder;

        for (let i = 1; i <= 9; i++) {
          sum = sum + parseInt(cleanedCPF.substring(i - 1, i)) * (11 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanedCPF.substring(9, 10))) {
          return 'CPF inválido';
        }

        sum = 0;
        for (let i = 1; i <= 10; i++) {
          sum = sum + parseInt(cleanedCPF.substring(i - 1, i)) * (12 - i);
        }

        remainder = (sum * 10) % 11;
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cleanedCPF.substring(10, 11))) {
          return 'CPF inválido';
        }

        return '';

      default:
        return '';
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Validar campo em tempo real
    if (errors[name]) {
      const fieldError = validateField(name, value);
      setErrors(prev => ({
        ...prev,
        [name]: fieldError
      }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    const fieldError = validateField(name, value);
    setErrors(prev => ({
      ...prev,
      [name]: fieldError
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    Object.keys(formData).forEach(field => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  
  const enviarParaGoogleSheets = async (dados) => {
    // URL real do Sheet.best
    const API_URL = 'https://api.sheetbest.com/sheets/49cbd199-6fc8-403c-930f-7db87813c33a';

    try {
      const response = await fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Api-Key': '4cjqJNw8nbmHnEKP_ywvU@o6MIReMElrcYt_87reebA20kVFa5wlHq%!JKPm@BSw'
        },
        body: JSON.stringify({
          "Nome": dados.nome,
          "Telefone": dados.telefone,
          "Email": dados.email,
          "CPF": dados.cpf,
          "Data": new Date().toLocaleString('pt-BR')
        })
      });

      if (response.ok) {
        console.log('✅ Dados salvos na planilha com sucesso');
        return true;
      } else {
        console.log(`⚠️ Erro na planilha: ${response.status} - ${response.statusText}`);
        return false;
      }
    } catch (error) {
      console.error('❌ Erro ao conectar com planilha:', error.message);
      return false;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);

    try {
      // Tentar enviar para Google Sheets
      const sheetsSuccess = await enviarParaGoogleSheets(formData);

      if (!sheetsSuccess) {
        console.log('Dados não salvos na planilha, mas inscrição continua válida');
      }

      // Mostrar sucesso mesmo que a planilha falhe
      setIsSuccess(true);
    } catch (error) {
      console.error('Erro no envio para planilha:', error);
      // Mesmo com erro na planilha, a inscrição é válida
      setIsSuccess(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      nome: '',
      telefone: '',
      email: '',
      cpf: ''
    });
    setErrors({});
    setIsSuccess(false);
  };

  if (isSuccess) {
    return (
      <div className="form-success">
        <div className="success-icon">✅</div>
        <h3>Inscrição realizada com sucesso!</h3>
        <p>Sua participação no sorteio da Raquete BeeTrue POISON BEE 2025 foi confirmada.</p>

        <div className="success-data">
          <h4>Seus dados:</h4>
          <div className="data-item">
            <strong>Nome:</strong> {formData.nome}
          </div>
          <div className="data-item">
            <strong>Telefone:</strong> {formData.telefone}
          </div>
          <div className="data-item">
            <strong>Email:</strong> {formData.email}
          </div>
          <div className="data-item">
            <strong>CPF:</strong> {formData.cpf}
          </div>
        </div>

        
        <button
          className="new-participation-btn"
          onClick={resetForm}
        >
          Fazer nova inscrição
        </button>
      </div>
    );
  }

  return (
    <form className="sorteio-form" onSubmit={handleSubmit}>
      <div className="form-header">
        <h3>Preencha seus dados</h3>
        <p>Participe do sorteio exclusivo da Raquete BeeTrue POISON BEE 2025</p>
      </div>

      <FormField
        label="Nome Completo"
        name="nome"
        value={formData.nome}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.nome}
        required
      />

      <FormField
        label="Telefone"
        type="tel"
        name="telefone"
        value={formData.telefone}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.telefone}
        placeholder="(11) 98765-4321"
        required
      />

      <FormField
        label="Email"
        type="email"
        name="email"
        value={formData.email}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.email}
        placeholder="seu@email.com"
        required
      />

      <FormField
        label="CPF"
        type="cpf"
        name="cpf"
        value={formData.cpf}
        onChange={handleChange}
        onBlur={handleBlur}
        error={errors.cpf}
        placeholder="123.456.789-00"
        required
      />

      <button
        type="submit"
        className="submit-btn"
        disabled={isSubmitting}
      >
        {isSubmitting ? (
          <span className="loading-spinner">
            <span className="spinner"></span>
            Processando...
          </span>
        ) : (
          'Participar do Sorteio'
        )}
      </button>

      <p className="form-terms">
        Ao participar, você concorda com os regulamentos do sorteio.
      </p>
    </form>
  );
};

export default Form;